import React from "react";
import { Navigate } from "react-router-dom";
import { FeatureFlagGate } from "./FeatureFlagGate";
import { useHasHgForceEnabled } from "../hooks/useHasHgForceEnabled";

interface SalesforceFeatureGateProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const SalesforceFeatureGate: React.FC<SalesforceFeatureGateProps> = ({
  children,
  fallback = <Navigate to="/" replace />,
}) => {
  const hasHgForceEnabled = useHasHgForceEnabled();

  // First check user claims/permissions
  if (!hasHgForceEnabled) {
    return <>{fallback}</>;
  }

  // Then check feature flag
  return (
    <FeatureFlagGate flagKey="salesforceRgiPlatform" fallback={fallback}>
      {children}
    </FeatureFlagGate>
  );
};
